import { Locks } from '@src/slide/domain/ui-model/element-modeles/property/lock/lock.interface';
import { ImageMeta } from '@src/slide/infrastructure/module/dependent/image/image-toolkit/image-meta-extractor';
import { ShapeType } from '@src/slide/infrastructure/module/dependent/shape-info/graphic-type';

export interface EditorImage {
    width: number;
    height: number;
    imageName: string;
    src: string;
    backupSrc?: string;
    imageType: string;
    prstGeom: {
        prstGeomType: string;
    };
    style?: {
        position: string;
        left: number;
        top: number;
        width: number;
        height: number;
        opacity: number;
        bgShape: ShapeType;
    };
}

export class EditorImageFactory {
    public static create(src: string, meta: ImageMeta): EditorImage {
        return {
            width: meta.width,
            height: meta.height,
            imageName: '',
            src,
            imageType: meta.type.split('/')[1],
            prstGeom: { prstGeomType: 'rect' },
            [Locks.LOCKS]: { noChangeAspect: 1 },
        };
    }
}

export default EditorImage;
